import { IRawData, ITreeNode } from "./interfaces"

export * from "./filter"

const queryTreeSort = (datas: IRawData[]): IRawData[] => {
  let ri: string[] = []
  const indexById = {}
  const childsById = {}
  const sortedDatas = []

  datas
    .sort((a, b) => a.name.localeCompare(b.name))
    .forEach((element, i) => {
      indexById[element.id] = i
      if (childsById[element.fatherId] == null) {
        childsById[element.fatherId] = []
      }
      if (element.fatherId === "" || element.fatherId === "NULL") {
        ri.push(element.id.toString())
      }
      childsById[element.fatherId].push(element.id)
    })

  while (ri.length) {
    const thisid = ri.splice(0, 1)[0]
    sortedDatas.push(datas[indexById[thisid]])
    if (childsById[thisid] != null) {
      // prepend childs ID before next id, so that childs are between this node and the next one
      ri = childsById[thisid].concat(ri)
    }
  }
  return sortedDatas
}

const makeTree = (datas: any[]): ITreeNode[] => {
  const temp = {}
  const tree: ITreeNode[] = []

  datas.forEach((jsonElement) => {
    temp[jsonElement.id] = jsonElement
    const father = temp[jsonElement.fatherId]

    if (father != null) {
      const parentPath = father.path === undefined ? "" : father.path
      temp[jsonElement.id].path =
        parentPath +
        (parentPath !== "" ? " / " : "") +
        temp[jsonElement.id].name
      if (father.children === undefined) {
        father.children = []
      }
      father.children.push(jsonElement)
    } else {
      jsonElement.path = ""
      tree.push(jsonElement)
    }
  })

  return tree
}

export const result = (rawDataa: IRawData[]): ITreeNode => {
  const sortedData = queryTreeSort(rawDataa)
  const tree = makeTree(sortedData)
  return tree[0]
}

export const searchNodeByValue = <T extends ITreeNode>(
  tree: ITreeNode[] | ITreeNode,
  matchingValue: string
): T | undefined => {
  if (Array.isArray(tree)) {
    let i
    let r
    for (i = 0; r === undefined && i < tree.length; i++) {
      r = searchNodeByValue<T>(tree[i], matchingValue)
    }
    return r
  } else if (tree.value + "" === matchingValue + "") {
    return tree as T
  } else if (tree.children !== undefined) {
    return searchNodeByValue<T>(tree.children as T[], matchingValue)
  }
  return undefined
}

export const searchNodeByCode = <T extends ITreeNode>(
  tree: ITreeNode[] | ITreeNode,
  matchingCode: string
): T | undefined => {
  if (Array.isArray(tree)) {
    let i
    let r
    for (i = 0; r === undefined && i < tree.length; i++) {
      r = searchNodeByCode<T>(tree[i], matchingCode)
    }
    return r
  } else if (tree.code + "" === matchingCode + "") {
    return tree as T
  } else if (tree.children !== undefined) {
    return searchNodeByCode<T>(tree.children as T[], matchingCode)
  }
  return undefined
}
